export default __webpack_public_path__ + "static/media/whatsapp.02ad52a6.svg";